import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/constants";

const WhatsAppButton = () => (
  <a
    data-testid="whatsapp-floating-button"
    href={waLink("Bonjour ANM Paris, je souhaiterais obtenir des informations sur vos parfums.")}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Contacter sur WhatsApp"
    className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/40 transition-transform duration-300 hover:scale-110 active:scale-95"
  >
    <MessageCircle size={26} />
  </a>
);

export default WhatsAppButton;
